'use client'

import { DynamicForm } from '@/components/shared/dynamic-form'
import { newsletterSubscribeAction } from '@/lib/actions'
import { FormState } from '@/lib/form'
import { formSchema } from '@/lib/newsletter'
import { zodResolver } from '@hookform/resolvers/zod'
import { useActionState } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const initialState: FormState = {
  success: false,
}

export function FooterNewsletter() {
  const [state, action] = useActionState(newsletterSubscribeAction, initialState)

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: '',
      acceptTerms: false,
    },
  })

  return (
    <div className={'col-span-2 lg:col-span-1'}>
      <span className="mb-3 block font-semibold">Newsletter</span>
      {!state.success && state.message && (
        <div className="mb-3">
          <p className="text-destructive text-sm">{state.message}</p>
        </div>
      )}
      {state.success && state.message && (
        <div className="mb-3">
          <p className="text-success text-sm">{state.message}</p>
        </div>
      )}
      {!state.success && !state.message && (
        <DynamicForm
          form={form}
          fields={[
            {
              type: 'email',
              name: 'email',
              placeholder: 'Email address',
            },
            {
              type: 'checkbox',
              name: 'acceptTerms',
              label: 'I confirm that I’ve read the privacy policy',
            },
          ]}
          submitButton={{
            label: 'Subscribe',
          }}
          action={action}
        />
      )}
    </div>
  )
}
